module.exports = __webpack_public_path__ + "logo-no-bg.7718b3e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-no-bg.svg
// module id = 212
// module chunks = 0